const services = [
  {
    icon: "ri-paint-brush-line",
    title: "İç Dekorasyon",
    desc: "Yaşam ve çalışma alanlarınızı estetik, fonksiyonel ve modern bir anlayışla yeniden tasarlıyoruz. Her detayda kalite.",
    color: "from-amber-50 to-orange-50",
  },
  {
    icon: "ri-tools-line",
    title: "Tadilat",
    desc: "Konut ve ticari alanlarda kapsamlı tadilat hizmetleri sunuyoruz. Güvenli, hızlı ve kalıcı çözümler.",
    color: "from-stone-50 to-gray-50",
  },
  {
    icon: "ri-star-line",
    title: "İnce İşçilik",
    desc: "Alçı, boya, kaplama ve tüm ince yapı işlerinde 22 yıllık deneyimimizle mükemmel sonuçlar elde ediyoruz.",
    color: "from-amber-50 to-yellow-50",
  },
  {
    icon: "ri-key-2-line",
    title: "Anahtar Teslim Projeler",
    desc: "Projenizin başından sonuna kadar tüm süreçleri yönetiyoruz. Siz sadece anahtarı teslim alın.",
    color: "from-stone-50 to-neutral-50",
  },
];

export default function ServicesSection() {
  return (
    <section id="hizmetler" className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
          <div>
            <span className="text-[#4CAF50] text-sm font-semibold uppercase tracking-widest mb-2 block">
              Ne Yapıyoruz?
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2B4A]">
              Hizmetlerimiz
            </h2>
          </div>
          <p className="text-[#718096] text-base max-w-sm lg:text-right">
            Anahtar teslim çözümlerden ince işçiliğe kadar geniş hizmet yelpazemizle yanınızdayız.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className={`bg-gradient-to-br ${service.color} rounded-2xl p-8 flex gap-6 items-start hover:shadow-md hover:-translate-y-1 transition-all duration-300 group cursor-default`}
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-white flex-shrink-0 group-hover:bg-[#4CAF50] transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-[#4CAF50] group-hover:text-white transition-colors duration-300`} />
              </div>
              <div>
                <h3 className="text-[#1A2B4A] font-bold text-xl mb-2">{service.title}</h3>
                <p className="text-[#4A5568] text-sm leading-relaxed">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
